import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import Autosuggest from 'react-autosuggest'
import { ah, ReduxWrapper, compose, QueryWrapper } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'
import { componentGetCompareProps } from 'common-tools/index'
import clsx from 'clsx'

class AutoSuggestBoxClassPlain extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      suggestionList: [],
      selectedSuggestion: {}
    }
  }

  static propTypes = buildPropTypes([

  ], {
    queryName: pt.string.isRequired,
    restoreValue: pt.any,
    hideClear: pt.bool.isRequired,
    extraDataMap: pt.oneOfType([
      pt.string,
      pt.arrayOf(pt.shape({
        Source: pt.string,
        Dest: pt.string
      })),
      pt.func
    ]),
    overrideSuggestionList: pt.func
  })

  static defaultProps = {
    hideClear: false
  }

  onSuggestionsClearRequested () {
    this.setState({
      suggestionList: []
    })
  }

  componentDidMount () {
    const { restoreValue } = this.props
    if (restoreValue) {
      this.restoreSuggestion(restoreValue)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const checkclearAutoSugg = componentGetCompareProps('clearAutoSugg', this.props, prevProps, '')
    if (checkclearAutoSugg.HasChanged) {
      if (checkclearAutoSugg.Current === true) {
        this.setState({
          selectedSuggestion: {}
        })
      }
    }

    const restoreValue = componentGetCompareProps('restoreValue', this.props, prevProps, '')
    if (restoreValue.HasChanged) {
      if (restoreValue) {
        this.setState({
          selectedSuggestion: {}
        })
        this.restoreSuggestion(restoreValue.Current)
      }
    }
  }

  restoreSuggestion (value) {
    const { queryName, GetSuggestions, formCheckForSubmissionErrors, formSetFieldValue, meta: { form }, extraDataMap } = this.props

    GetSuggestions({
      Name: queryName,
      SearchText: null,
      RestoreValue: value
    }).then(({ data }) => {
      let suggestion = data[0] || {}
      this.setState({
        selectedSuggestion: suggestion
      }, () => {
        if (extraDataMap) {
          let extraData = suggestion.ExtraData || {}
          if (_.isString(extraDataMap)) {
            formSetFieldValue(form, extraDataMap, suggestion.Text)
          } else if (_.isArray(extraDataMap)) {
            for (var mapInfo of extraDataMap) {
              if (_.has(extraData, mapInfo.Source)) {
                formSetFieldValue(form, mapInfo.Dest, extraData[mapInfo.Source])
              }
            }
          } else if (_.isFunction(extraDataMap)) {
            extraDataMap(suggestion, extraData, (field, value) => {
              formSetFieldValue(form, field, value, 'set')
            })
          } else {
            throw Error('Invalid extraDataMap, must be a string, array, or function!')
          }
        }
      })
    }).catch(formCheckForSubmissionErrors)
  }

  getDebounce () {
    const { debounceValue = 500 } = this.props
    return debounceValue
  }

  fetchSuggestions = _.debounce((value) => {
    const { queryName, GetSuggestions, formCheckForSubmissionErrors, overrideSuggestionList } = this.props
    if (value.length > 2) {
      console.log({ value })
      GetSuggestions({
        Name: queryName,
        SearchText: value,
        RestoreValue: null
      }).then(({ data }) => {
        let newData = _.clone(data)
        if (_.isFunction(overrideSuggestionList)) {
          overrideSuggestionList(newData)
        }
        this.setState({
          suggestionList: newData || []
        })
      }).catch(formCheckForSubmissionErrors)
    }
  }, this.getDebounce())

  onSuggestionsFetchRequested ({ value, reason }) {
    if (reason === 'input-changed') {
      this.fetchSuggestions(value)
    }
  }

  onSuggestionSelected (event, { suggestion }) {
    if (suggestion.Value === 'No Matches' || suggestion.Value === 'Searching...') {
      event.stopPropagation()
      event.nativeEvent.stopImmediatePropagation()
      return
    }

    const { input: { onChange }, formSetFieldValue, meta: { form }, extraDataMap } = this.props

    this.setState({
      selectedSuggestion: suggestion
    }, () => {
      onChange(suggestion.Value)
      if (extraDataMap) {
        let extraData = suggestion.ExtraData || {}
        if (_.isString(extraDataMap)) {
          // just set this field to the Text of the selected value
          formSetFieldValue(form, extraDataMap, suggestion.Text)
        } else if (_.isArray(extraDataMap)) {
          for (var mapInfo of extraDataMap) {
            if (_.has(extraData, mapInfo.Source)) {
              formSetFieldValue(form, mapInfo.Dest, extraData[mapInfo.Source])
            }
          }
        } else if (_.isFunction(extraDataMap)) {
          extraDataMap(suggestion, extraData, (field, value) => {
            formSetFieldValue(form, field, value, 'set')
          })
        } else {
          throw Error('Invalid extraDataMap, must be a string, array, or function!')
        }
      }
    })
  }

  clearSelectedSuggestion () {
    const { input: { onChange }, formSetFieldValue, meta: { form }, extraDataMap } = this.props
    this.setState({
      selectedSuggestion: {}
    }, () => {
      onChange(null)
      if (extraDataMap) {
        let extraData = {}
        if (_.isString(extraDataMap)) {
          // just set this field to the Text of the selected value
          formSetFieldValue(form, extraDataMap, null)
        } else if (_.isArray(extraDataMap)) {
          for (var mapInfo of extraDataMap) {
            if (_.has(extraData, mapInfo.Source)) {
              formSetFieldValue(form, mapInfo.Dest, null)
            }
          }
        } else if (_.isFunction(extraDataMap)) {
          extraDataMap({}, extraData, (field, value) => {
            formSetFieldValue(form, field, value, 'clear')
          })
        } else {
          throw Error('Invalid extraDataMap, must be a string, array, or function!')
        }
      }
    })
  }

  render () {
    const { data, setValue, hideClear, ...rest } = this.props
    const { suggestionList, selectedSuggestion } = this.state
    let suggestions = suggestionList

    if (data.loadingGetSuggestions) {
      suggestions = [{ Value: 'Searching...' }]
    } else {
      if (suggestionList.length === 0) {
        suggestions = [{ Value: 'No Matches' }]
      }
    }

    return (
      <FieldLayoutBox {...rest}>
        {({ testId, showError, value, onChange, name, placeHolder, loading }) => {
          if (selectedSuggestion.Value) {
            if (data.loadingGetSuggestions) {
              return <input data-tid={testId} type='text' readOnly name={`viewsuggestfetching${name}`} id={`viewsuggestfetching${name}`} value={'Fetching...'} />
            } else {
              if (hideClear) {
                return <input data-tid={testId} type='text' readOnly name={`viewsuggest${name}`} id={`viewsuggest${name}`} value={selectedSuggestion.Text} />
              } else {
                return (
                  <FieldLayoutGroup
                    groupButton={{
                      onClick: this.clearSelectedSuggestion.bind(this),
                      text: 'Clear',
                      color: 'secondary'
                    }}>
                    <input type='text' data-tid={testId} readOnly name={`viewsuggest${name}`} className={clsx(showError && 'is-invalid-input', 'input-group-field')} id={`viewsuggest${name}`} value={setValue ? selectedSuggestion.Value : selectedSuggestion.Text} />
                  </FieldLayoutGroup>
                )
              }
            }
          } else {
            return <Autosuggest
              inputProps={{
                onChange: (event, props) => {
                  const { newValue } = props
                  onChange(newValue)
                },
                value: value || '',
                placeholder: placeHolder,
                disabled: loading,
                invalid: showError,
                className: clsx(showError && 'is-invalid-input'),
                onBlur: () => {
                  if (!selectedSuggestion.Value) {
                    onChange(null)
                  }
                }
              }}
              id={`textsuggest${name}`}
              name={`textsuggest${name}`}
              data-tid={testId}
              suggestions={suggestions}
              renderSuggestion={(suggestion) =>
                <div>
                  {suggestion.Text || suggestion.Value || '???'}
                </div>
              }
              getSuggestionValue={suggestion => suggestion.Text}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
              onSuggestionSelected={this.onSuggestionSelected.bind(this)}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
            />
          }
        }}
      </FieldLayoutBox>
    )
  }
}

const autoSuggestBoxes = new Map()

const BuildAutoSuggestBox = (name) => {
  let ret = autoSuggestBoxes.get(name)

  if (!ret) {
    ret = compose(
      ReduxWrapper([

      ], [
        ah.formCheckForSubmissionErrors,
        ah.formSetFieldValue
      ]),
      QueryWrapper({
        key: `AutoSuggest`,
        actions: [
          {
            url: '/Services/Data/AutoSuggest/Get',
            prop: 'GetSuggestions',
            map: false
          }
        ]
      })
    )(AutoSuggestBoxClassPlain)
    autoSuggestBoxes.set(name, ret)
  }

  return ret
}

export const AutoSuggestBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={BuildAutoSuggestBox(rest.name)} /> } // eslint-disable-line
export default AutoSuggestBox
